<div class="footer">
	<div class="branded-asset-logo-grey"></div>
	<div>©Copyright 2016-{{year}} | GPMS International, Inc.</div>
</div>